import React from 'react';
import Tag from 'features/issues/components/Tag';

/** Every status an issue can have (backend/services/issues/store.js). */
export const STATUS = {
  open: { label: 'Open', tone: 'warning', dot: 'var(--feedback-warning)' },
  regression: { label: 'Regression', tone: 'error', dot: 'var(--feedback-error)' },
  closed: { label: 'Closed', tone: 'success', dot: 'var(--feedback-success)' },
  merged: { label: 'Merged', tone: 'neutral', dot: 'var(--text-disabled)' },
};

/** What kind of fix an issue needs. Ask sets it when it files. */
export const CATEGORY = {
  code: { label: 'Code', hint: 'A bug in the agent’s own code' },
  prompt: { label: 'Prompt', hint: 'The instructions lead the model wrong' },
  tool: { label: 'Tool', hint: 'A tool or external API misbehaves, or is called against its contract' },
  infrastructure: { label: 'Infrastructure', hint: 'Timeouts, rate limits, capacity, credentials, config' },
  data: { label: 'Data', hint: 'Retrieval or data is missing, stale or wrong' },
  model: { label: 'Model', hint: 'The model fails with the right context' },
};

export function StatusTag({ status }) {
  const s = STATUS[status] || { label: status, tone: 'neutral' };
  return <Tag tone={s.tone}>{s.label}</Tag>;
}

/** The status as a dot, the way Runs and Spans rows show theirs. */
export function StatusDot({ status }) {
  const s = STATUS[status] || { label: status || 'Unknown', dot: 'var(--text-disabled)' };
  return (
    <span
      role="img"
      aria-label={s.label}
      title={s.label}
      data-status={status}
      className="inline-block h-2 w-2 shrink-0 rounded-full"
      style={{ backgroundColor: s.dot }}
    />
  );
}

export function CategoryTag({ category }) {
  const c = CATEGORY[category];
  if (!c) return null;
  return <Tag tone="info" title={c.hint}>{c.label}</Tag>;
}
